var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"btn",class:_vm.activeState ? _vm.activeClasses: _vm.inactiveClasses,style:({fontSize: '0.9rem'}),domProps:{"textContent":_vm._s(_vm.activeState ? _vm.activeText: _vm.inactiveText)}})
}
var staticRenderFns = []

export { render, staticRenderFns }